export default function () {
   return {
      moviesList: [],
      employees: [],
      popular: {},
      movie: {},
   }
}